export const queryKeys = {
  projects: ['projects'] as const,
  projectListingStats: ['projects', 'listing-stats'] as const,
  billingSnapshot: (userId: string) => ['billing', 'subscription', userId] as const,
  stagingTestPlan: (userId: string) => ['billing', 'staging-test-plan', userId] as const,
  insightsSummary: (timeframe: string, userId: string | null) =>
    ['insights', 'summary', timeframe, userId ?? 'all-users'] as const,
  insightEmailTemplates: ['insights', 'email-templates'] as const,
  collections: (projectId: string) => ['projects', projectId, 'collections'] as const,
  collectionConfig: (projectId: string, collectionName: string) =>
    ['projects', projectId, 'collections', collectionName, 'config'] as const,
  collectionFields: (projectId: string, collectionName: string) =>
    ['projects', projectId, 'collections', collectionName, 'fields'] as const,
  collectionFieldUsage: (projectId: string, collectionName: string) =>
    ['projects', projectId, 'collections', collectionName, 'field-usage'] as const,
  activeRuns: (projectId: string) => ['projects', projectId, 'runs', 'active'] as const,
  collectionRuns: (projectId: string, collectionName: string) =>
    ['projects', projectId, 'collections', collectionName, 'runs'] as const,
  syncHistory: (projectId: string, collectionName: string, page: number, pageSize: number) =>
    [...queryKeys.collectionRuns(projectId, collectionName), page, pageSize] as const,
  automation: (projectId: string, collectionName: string) =>
    ['projects', projectId, 'collections', collectionName, 'automation'] as const,
  subscriptionAccess: (userId: string) => ['billing', 'subscription-access', userId] as const,
  framerData: (projectId: string, collectionName: string) =>
    ['projects', projectId, 'collections', collectionName, 'framer-data'] as const,
  dashboardRuns: (projectId: string, collectionName: string) =>
    ['projects', projectId, 'collections', collectionName, 'dashboard-runs'] as const,
  runDetail: (projectId: string, runId: string) =>
    ['projects', projectId, 'runs', runId, 'detail'] as const,
};
